export const environment = {
    production: true,
    API: 'https://api.ca.govworks.com/api/'
}
